import api from '@/api'

const { $core, $pricing } = api;

export const { $banners } = $core;
export const { $types } = $pricing;

